export class Contactus {
    name: string;
    email: string;
    phone?:string;
    message:string;
    createdAt: Date;
}
